function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { primary700, primary600, primary400, primary300, white } from '../theme/colors';
import { size24, size32, size40, size64, size96 } from '../theme/scale';
const SIZE_MAP = {
  xs: size24,
  sm: size32,
  md: size40,
  lg: size64,
  xl: size96
};
const COLOR_MAP = {
  primary: 'primary',
  white
};
const Wrapper = styled.svg`
  fill: ${({
  fill
}) => fill};
  width: 100%;
  max-height: ${({
  size
}) => size};
`;
export const Logo = ({
  color = 'primary',
  size = SIZE_MAP.sm,
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, _extends({
  role: "img",
  "aria-labelledby": "ableto-logo",
  xmlns: "http://www.w3.org/2000/svg",
  size: SIZE_MAP[size]
}, props, {
  viewBox: "0 0 476 96"
}), color === 'primary' ? /*#__PURE__*/React.createElement(PrimaryLogo, null) : /*#__PURE__*/React.createElement(WhiteLogo, null));
export const PrimaryLogo = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", {
  id: "ableto-logo"
}, "AbleTo Logo"), /*#__PURE__*/React.createElement("g", {
  role: "presentation"
}, /*#__PURE__*/React.createElement("path", {
  d: "M134.006 73.925l-7.339 20.724h-19.212L141.257 0h17.308l33.802 94.634h-19.226l-7.339-20.723h-31.796v.014zm15.898-49.075l-11.408 34.122h22.801L149.904 24.85zm64.683 69.784h-17.279V0h17.846v36.229c2.107-7.368 9.111-12.963 17.511-12.963 13.675 0 26.841 9.446 26.841 29.995V65.7c0 20.548-13.806 30.285-26.841 30.285-9.184 0-15.084-6.119-18.078-11.03v9.678zm27.073-40.69c0-9.33-6.495-13.515-13.253-13.515-6.757 0-13.253 4.185-13.253 13.515v11.088c0 9.33 6.496 13.515 13.253 13.515 6.758 0 13.253-4.185 13.253-13.515V53.944zm72.008 9.039v3.27c0 8.24 4.592 13.66 13.253 13.66 6.351 0 10.551-2.98 12.309-7.702h18.122C354.518 86.816 344.244 96 326.936 96c-20.011 0-31.099-12.701-31.099-32.044v-8.922c0-19.328 11.088-32.044 31.099-32.044 20.011 0 31.099 12.716 31.099 32.044v7.949h-44.367zm0-9.679h26.361v-1.453c0-.581-.014-1.177-.087-1.758-.814-6.903-5.246-11.016-13.035-11.016-7.092 0-11.408 3.619-12.818 9.33-.32 1.293-.436 2.63-.436 3.953v.944h.015zM291.986 81.41v13.224h-6.613c-12.439 0-17.845-6.496-17.845-17.846V0h17.845v74.943c0 3.836 2.82 6.467 6.293 6.467h.32z",
  fill: primary600
}), /*#__PURE__*/React.createElement("path", {
  d: "M399.452 17.976v76.658h-18.66V17.976h-26.361V0h71.382v17.976h-26.361z",
  fill: primary300
}), /*#__PURE__*/React.createElement("path", {
  d: "M445.112 22.99c-20.011 0-31.099 12.716-31.099 32.044v8.908c0 19.328 11.088 32.044 31.099 32.044 20.011 0 31.099-12.702 31.099-32.044v-8.923c0-19.328-11.088-32.029-31.099-32.029zm13.253 43.263c0 8.24-4.592 13.66-13.253 13.66-8.647 0-13.253-5.406-13.253-13.66V52.736c0-8.24 4.592-13.66 13.253-13.66 8.647 0 13.253 5.406 13.253 13.66v13.515zM90.84 86.86H72.56V18.28C72.56 8.182 80.742 0 90.84 0v86.86z",
  fill: primary300
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.912 91.843l-34.29-59.381c-5.042-8.757-2.05-19.931 6.692-24.988L90.84 77.72 77.912 91.843z",
  fill: primary400
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.258 95.19L21.863 60.9c-8.742-5.042-11.735-16.232-6.693-24.974l75.228 43.43-9.14 15.833z",
  fill: primary600
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.84 96H18.28C8.182 96 0 87.818 0 77.72h90.84V96z",
  fill: primary700
})));
export const WhiteLogo = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", {
  id: "ableto-logo"
}, "AbleTo Logo"), /*#__PURE__*/React.createElement("g", {
  role: "presentation"
}, /*#__PURE__*/React.createElement("path", {
  d: "M134.371 74.146l-7.338 20.723h-19.212L141.623.221h17.308l33.802 94.634h-19.226l-7.339-20.723h-31.797v.014zm15.899-49.075l-11.408 34.122h22.801L150.27 25.07zm64.683 69.784h-17.279V.22h17.845V36.45c2.108-7.368 9.112-12.963 17.512-12.963 13.675 0 26.841 9.446 26.841 29.995v12.44c0 20.548-13.806 30.284-26.841 30.284-9.185 0-15.085-6.118-18.078-11.03v9.679zm27.073-40.69c0-9.33-6.496-13.515-13.253-13.515-6.758 0-13.254 4.185-13.254 13.515v11.088c0 9.33 6.496 13.515 13.254 13.515 6.757 0 13.253-4.186 13.253-13.515V54.165zm72.008 9.039v3.27c0 8.24 4.592 13.66 13.253 13.66 6.351 0 10.55-2.98 12.309-7.702h18.122c-2.834 14.605-13.109 23.789-30.416 23.789-20.011 0-31.099-12.701-31.099-32.044v-8.923c0-19.327 11.088-32.043 31.099-32.043 20.01 0 31.099 12.716 31.099 32.044v7.949h-44.367zm0-9.679h26.361v-1.453c0-.581-.014-1.177-.087-1.759-.814-6.902-5.246-11.015-13.036-11.015-7.091 0-11.407 3.619-12.817 9.33-.32 1.293-.436 2.63-.436 3.953v.944h.015zM292.351 81.63v13.225h-6.612c-12.439 0-17.845-6.496-17.845-17.846V.221h17.845v74.943c0 3.836 2.82 6.466 6.293 6.466h.319zM399.817 18.197v76.658h-18.659V18.197h-26.361V.221h71.382v17.976h-26.362z",
  fill: white
}), /*#__PURE__*/React.createElement("path", {
  d: "M445.478 23.21c-20.011 0-31.099 12.717-31.099 32.044v8.909c0 19.328 11.088 32.043 31.099 32.043 20.011 0 31.099-12.7 31.099-32.043V55.24c0-19.328-11.088-32.03-31.099-32.03zm13.253 43.263c0 8.24-4.592 13.66-13.253 13.66-8.647 0-13.254-5.405-13.254-13.66V52.958c0-8.24 4.593-13.66 13.254-13.66 8.647 0 13.253 5.406 13.253 13.66v13.515zM72.866 42.655l18.28 28.63V.22c-10.098 0-18.28 8.182-18.28 18.28v24.154zM72.772 45.89L50.587 7.862c-8.743 5.057-11.735 16.231-6.693 24.988l15.623 27.006 31.63 14.61-18.375-28.578zM91.146 96.39h-72.56C8.488 96.39.306 88.206.306 78.11h90.84v18.28z",
  fill: white
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.189 76.314h42.954l-30.26-13.86-45.33-26.074c-5.042 8.742-2.05 19.93 6.693 24.973l25.943 14.96z",
  fill: white
})));
export default Logo;
//# sourceMappingURL=index.js.map